// extracted by mini-css-extract-plugin
module.exports = {"required":"Label_required__1JSRf","root":"Label_root__1xmrD"};